<!--
	@name app-common-promotion-advisor-advert
	@description Account Page
	@date 2020/04/24
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name">
		<v-sheet v-if="hasBanner && banners.length" :class="classes">
			<common-promotion-carousel :adverts="banners" orientation="landscape" @clicked="clicked" />
		</v-sheet>
	</div>
</template>

<script>
	import { mapActions, mapState } from 'vuex';
	import CommonPromotionCarousel from '@/component/common/promotion/carousel';

	export default {
		name: 'app-common-promotion-advisor-advert',

		components: {
			CommonPromotionCarousel
		},

		props: {
			overrides: { type: Array, required: false, default: () => [] },
			classes: { type: String, required: false, default: "pa-5" }
		},

		data() {
			return {
				banners: []
			};
		},

		computed: {
			...mapState('CmsSite', ['site']),

			hasBanner() {
				return this.overrides.length || this.site.adverts?.advisor;
			}
		},

		created() {
			if(this.overrides.length) this.banners = this.overrides;
			else {
				this.loadAdvisorBanner().then(({ data }) => {
					if(data?.value.dashboard_right) this.banners = [data.value.dashboard_right];
				});
			}
		},

		methods: {
			...mapActions('CmsBanner', ['loadAdvisorBanner']),

			clicked() {
				this.$emit('clicked');
			}
		}
	};
</script>
